import { render, staticRenderFns } from "./SignerSettings.vue?vue&type=template&id=1d745f12&scoped=true&"
import script from "./SignerSettings.vue?vue&type=script&lang=js&"
export * from "./SignerSettings.vue?vue&type=script&lang=js&"
import style0 from "./SignerSettings.vue?vue&type=style&index=0&id=1d745f12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d745f12",
  null
  
)

export default component.exports